import type { SelectableMessageType } from "@lib/campaignMessageTypeConstants";

import { getChannelForMessageType } from "./getChannelForMessageType";

export const hasContentOptimizationSupportedChannel = (messageTypes: readonly SelectableMessageType[]): boolean =>
  messageTypes.some((messageType) => getChannelForMessageType(messageType) !== undefined);
